export const getWordPressData = async (url) => {
    try {
        const response = await fetch(url);
        if (!response.ok)
            throw new Error(`Erro ${response.status}: ${response.statusText}`);

        const content = await response.json();
        content.reverse();
        
        return content;
    } catch (error) {
        console.error(error);
        return null;
    }
};
